module.exports = __webpack_public_path__ + "img/logo1.4320ca44.png";